import React, { useState, useEffect, useRef, useCallback } from 'react';
import GestorLayout from '../../components/GestorLayout';
import axios from 'axios';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { 
  Dialog, DialogContent, DialogHeader, DialogTitle 
} from '../../components/ui/dialog';
import { toast } from 'sonner';
import { 
  Clock, 
  Calendar, 
  Plus, 
  Trash2, 
  Save,
  Sun,
  Coffee,
  Settings,
  Palmtree,
  AlertCircle,
  HeartPulse,
  FileText,
  User,
  Check,
  X,
  ChevronLeft,
  ChevronRight,
  Edit,
  List,
  Grid,
  BarChart3,
  Users,
  Bell,
  MessageSquareQuote,
  Copy,
  CheckCircle2,
  Globe,
  LogOut
} from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DIAS_SEMANA = [
  { valor: 0, nome: 'Domingo', abrev: 'Dom' },
  { valor: 1, nome: 'Segunda', abrev: 'Seg' },
  { valor: 2, nome: 'Terça', abrev: 'Ter' },
  { valor: 3, nome: 'Quarta', abrev: 'Qua' },
  { valor: 4, nome: 'Quinta', abrev: 'Qui' },
  { valor: 5, nome: 'Sexta', abrev: 'Sex' },
  { valor: 6, nome: 'Sábado', abrev: 'Sáb' }
];

const FERIADOS_PORTUGAL = [
  { data: '2026-01-01', nome: 'Ano Novo' },
  { data: '2026-04-03', nome: 'Sexta-feira Santa' },
  { data: '2026-04-05', nome: 'Páscoa' },
  { data: '2026-04-25', nome: 'Dia da Liberdade' },
  { data: '2026-05-01', nome: 'Dia do Trabalhador' },
  { data: '2026-06-04', nome: 'Corpo de Deus' },
  { data: '2026-06-10', nome: 'Dia de Portugal' },
  { data: '2026-08-15', nome: 'Assunção de Nossa Senhora' },
  { data: '2026-10-05', nome: 'Implantação da República' },
  { data: '2026-11-01', nome: 'Todos os Santos' },
  { data: '2026-12-01', nome: 'Restauração da Independência' },
  { data: '2026-12-08', nome: 'Imaculada Conceição' },
  { data: '2026-12-25', nome: 'Natal' },
  { data: '2027-01-01', nome: 'Ano Novo' },
  { data: '2027-03-26', nome: 'Sexta-feira Santa' },
  { data: '2027-03-28', nome: 'Páscoa' },
  { data: '2027-04-25', nome: 'Dia da Liberdade' },
  { data: '2027-05-01', nome: 'Dia do Trabalhador' },
  { data: '2027-05-27', nome: 'Corpo de Deus' },
  { data: '2027-06-10', nome: 'Dia de Portugal' },
  { data: '2027-08-15', nome: 'Assunção de Nossa Senhora' },
  { data: '2027-10-05', nome: 'Implantação da República' },
  { data: '2027-11-01', nome: 'Todos os Santos' },
  { data: '2027-12-01', nome: 'Restauração da Independência' },
  { data: '2027-12-08', nome: 'Imaculada Conceição' },
  { data: '2027-12-25', nome: 'Natal' },
];

const TABS = [
  { id: 'geral', label: 'Geral', icon: Settings },
  { id: 'horarios', label: 'Horários', icon: Clock },
  { id: 'ferias', label: 'Férias', icon: Calendar },
  { id: 'frases', label: 'Frases Motivacionais', icon: MessageSquareQuote }
];

// Lista de fusos horários comuns
const TIMEZONES = [
  { value: 'Europe/Lisbon', label: 'Lisboa (Portugal)' },
  { value: 'Europe/London', label: 'Londres (Reino Unido)' },
  { value: 'Europe/Madrid', label: 'Madrid (Espanha)' },
  { value: 'Europe/Paris', label: 'Paris (França)' },
  { value: 'Europe/Berlin', label: 'Berlim (Alemanha)' },
  { value: 'Atlantic/Azores', label: 'Açores (Portugal)' },
  { value: 'Atlantic/Madeira', label: 'Madeira (Portugal)' },
  { value: 'America/Sao_Paulo', label: 'São Paulo (Brasil)' },
  { value: 'Africa/Luanda', label: 'Luanda (Angola)' },
  { value: 'Africa/Maputo', label: 'Maputo (Moçambique)' },
  { value: 'Asia/Macau', label: 'Macau' },
  { value: 'Asia/Dili', label: 'Díli (Timor-Leste)' },
  { value: 'UTC', label: 'UTC (Coordenado Universal)' }
];

// Cores disponíveis para tipos de ausência
const CORES_DISPONIVEIS = [
  { cor: 'bg-blue-500', corLight: 'bg-blue-50', textColor: 'text-blue-600' },
  { cor: 'bg-red-500', corLight: 'bg-red-50', textColor: 'text-red-600' },
  { cor: 'bg-orange-500', corLight: 'bg-orange-50', textColor: 'text-orange-600' },
  { cor: 'bg-purple-500', corLight: 'bg-purple-50', textColor: 'text-purple-600' },
  { cor: 'bg-green-500', corLight: 'bg-green-50', textColor: 'text-green-600' },
  { cor: 'bg-pink-500', corLight: 'bg-pink-50', textColor: 'text-pink-600' },
  { cor: 'bg-teal-500', corLight: 'bg-teal-50', textColor: 'text-teal-600' },
  { cor: 'bg-indigo-500', corLight: 'bg-indigo-50', textColor: 'text-indigo-600' },
];

const ESTADO_AUSENCIA = {
  pendente: { label: 'Pendente', color: 'bg-amber-500' },
  aprovado: { label: 'Aprovado', color: 'bg-green-500' },
  rejeitado: { label: 'Rejeitado', color: 'bg-red-500' },
};

export default function Configuracoes() {
  const [activeTab, setActiveTab] = useState('geral');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const currentYear = new Date().getFullYear();
  const [isDirty, setIsDirty] = useState(false);
  const [showUnsavedDialog, setShowUnsavedDialog] = useState(false);
  const pendingTabRef = useRef(null);
  
  // Marcar dirty quando o utilizador altera configurações
  const markDirty = useCallback(() => { setIsDirty(true); }, []);
  
  // Tentar mudar de tab — se dirty, perguntar
  const handleTabChange = useCallback((newTab) => {
    if (isDirty) {
      pendingTabRef.current = newTab;
      setShowUnsavedDialog(true);
    } else {
      setActiveTab(newTab);
    }
  }, [isDirty]);
  
  // Estado das configurações gerais
  const [configGeral, setConfigGeral] = useState({
    timezone: 'Europe/Lisbon',
    formato_data: 'dd/MM/yyyy',
    formato_hora: '24h'
  });
  
  // Estado da configuração de horários
  const [config, setConfig] = useState({
    horario_inicio: '08:00',
    horario_fim: '17:00',
    intervalo_almoco_inicio: '12:00',
    intervalo_almoco_fim: '13:00',
    pausas_adicionais: [],
    motivos_pausa: ['Falta de trabalho', 'Casa de banho', 'Erro', 'Aguardando material', 'Problema técnico', 'Outros'],
    dias_trabalho: [1, 2, 3, 4, 5],
    feriados: [],
    dias_ferias_anuais: 22
  });
  
  // Estado das férias/ausências
  const [ausencias, setAusencias] = useState([]);
  const [operadores, setOperadores] = useState([]);
  const [tiposAusencia, setTiposAusencia] = useState([
    { id: 'ferias', nome: 'Férias', cor: 'bg-blue-500', corLight: 'bg-blue-50', textColor: 'text-blue-600', icon: 'Palmtree' },
    { id: 'falta', nome: 'Falta', cor: 'bg-red-500', corLight: 'bg-red-50', textColor: 'text-red-600', icon: 'AlertCircle' },
    { id: 'baixa', nome: 'Baixa Médica', cor: 'bg-orange-500', corLight: 'bg-orange-50', textColor: 'text-orange-600', icon: 'HeartPulse' },
    { id: 'licenca', nome: 'Licença', cor: 'bg-purple-500', corLight: 'bg-purple-50', textColor: 'text-purple-600', icon: 'FileText' },
  ]);
  
  // UI states
  const [showFormAusencia, setShowFormAusencia] = useState(false);
  const [showFormTipo, setShowFormTipo] = useState(false);
  const [showBalancoDialog, setShowBalancoDialog] = useState(false);
  const [editingTipo, setEditingTipo] = useState(null);
  const [filtroEstadoAusencia, setFiltroEstadoAusencia] = useState('');
  const [viewMode, setViewMode] = useState('calendario'); // 'calendario' ou 'lista'
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [showDayDetail, setShowDayDetail] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [balancoOperadores, setBalancoOperadores] = useState([]);
  
  const [formAusencia, setFormAusencia] = useState({
    operador_id: '',
    data_inicio: '',
    data_fim: '',
    tipo: 'ferias',
    observacoes: ''
  });
  
  const [formTipo, setFormTipo] = useState({
    nome: '',
    cor: 'bg-blue-500',
    corLight: 'bg-blue-50',
    textColor: 'text-blue-600'
  });
  
  const [novoFeriado, setNovoFeriado] = useState({ data: '', nome: '' });
  const [novaPausa, setNovaPausa] = useState({ inicio: '', fim: '', descricao: '' });
  
  // Estado dos Alertas
  const [alertas, setAlertas] = useState([]);
  const [novoAlerta, setNovoAlerta] = useState({
    titulo: '',
    mensagem: '',
    data_notificacao: '',
    destinatarios: 'todos',
    prioridade: 'normal'
  });
  const [editandoAlerta, setEditandoAlerta] = useState(null);
  const [showFormAlerta, setShowFormAlerta] = useState(false);
  
  // Estado das Frases Motivacionais
  const [frases, setFrases] = useState([]);
  const [novaFrase, setNovaFrase] = useState({ texto: '', ativa: true, mostrar_em: ['login', 'fim_tarefa'] });
  const [editandoFrase, setEditandoFrase] = useState(null);
  const [showFormFrase, setShowFormFrase] = useState(false);

  useEffect(() => {
    loadAllData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadAllData = async () => {
    setLoading(true);
    try {
      const [configRes, configGeralRes, ausenciasRes, operadoresRes, tiposRes, alertasRes, frasesRes] = await Promise.all([
        axios.get(`${API}/configuracao`).catch(() => ({ data: {} })),
        axios.get(`${API}/configuracoes/geral`).catch(() => ({ data: null })),
        axios.get(`${API}/ausencias`).catch(() => ({ data: [] })),
        axios.get(`${API}/operadores`).catch(() => ({ data: [] })),
        axios.get(`${API}/tipos-ausencia`).catch(() => ({ data: null })),
        axios.get(`${API}/configuracoes/alertas`).catch(() => ({ data: [] })),
        axios.get(`${API}/configuracoes/frases-motivacionais`).catch(() => ({ data: [] }))
      ]);
      
      if (configRes.data) {
        setConfig({ ...config, ...configRes.data });
      }
      
      // Carregar configurações gerais (timezone, etc.)
      if (configGeralRes.data) {
        setConfigGeral({ ...configGeral, ...configGeralRes.data });
      }
      
      setAusencias(ausenciasRes.data || []);
      setOperadores((operadoresRes.data || []).filter(o => o.perfil === 'operador'));
      setAlertas(alertasRes.data || []);
      setFrases(frasesRes.data || []);
      
      // Se existir tipos de ausência no backend, usar
      if (tiposRes.data && Array.isArray(tiposRes.data) && tiposRes.data.length > 0) {
        setTiposAusencia(tiposRes.data);
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  // Guardar configuração
  const handleSaveConfig = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/configuracao`, config);
      toast.success('Configuração guardada com sucesso!');
      setIsDirty(false);
    } catch (error) {
      toast.error('Erro ao guardar configuração');
    } finally {
      setSaving(false);
    }
  };

  // Guardar configurações gerais (timezone, formatos, etc.)
  const handleSaveConfigGeral = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/configuracoes/geral`, configGeral);
      toast.success('Configurações gerais guardadas com sucesso!');
      setIsDirty(false);
      // Disparar evento para que outros componentes actualizem as configurações
      window.dispatchEvent(new CustomEvent('configChanged', { detail: configGeral }));
    } catch (error) {
      toast.error('Erro ao guardar configurações gerais');
    } finally {
      setSaving(false);
    }
  };

  // Toggle dia de trabalho
  const toggleDiaTrabalho = (dia) => {
    if (config.dias_trabalho.includes(dia)) {
      setConfig({ ...config, dias_trabalho: config.dias_trabalho.filter(d => d !== dia) });
    } else {
      setConfig({ ...config, dias_trabalho: [...config.dias_trabalho, dia].sort((a, b) => a - b) });
    }
  };

  // Feriados
  const addFeriado = async () => {
    if (!novoFeriado.data || !novoFeriado.nome) {
      toast.error('Preencha a data e o nome do feriado');
      return;
    }
    const novosFeriados = [...(config.feriados || []), { ...novoFeriado }].sort((a, b) => a.data.localeCompare(b.data));
    setConfig({ ...config, feriados: novosFeriados });
    setNovoFeriado({ data: '', nome: '' });
    
    // Guardar automaticamente
    try {
      await axios.put(`${API}/configuracao`, { ...config, feriados: novosFeriados });
      toast.success('Feriado adicionado!');
    } catch (error) {
      toast.error('Erro ao guardar feriado');
    }
  };

  const removeFeriado = async (data) => {
    const novosFeriados = (config.feriados || []).filter(f => f.data !== data);
    setConfig({ ...config, feriados: novosFeriados });
    
    // Guardar automaticamente
    try {
      await axios.put(`${API}/configuracao`, { ...config, feriados: novosFeriados });
    } catch (error) {
      toast.error('Erro ao remover feriado');
    }
  };

  const loadFeriadosPortugal = async () => {
    const feriadosAtuais = config.feriados || [];
    const novos = FERIADOS_PORTUGAL.filter(fp => !feriadosAtuais.some(fa => fa.data === fp.data));
    const novosFeriados = [...feriadosAtuais, ...novos].sort((a, b) => a.data.localeCompare(b.data));
    setConfig({ ...config, feriados: novosFeriados });
    
    // Guardar automaticamente
    try {
      await axios.put(`${API}/configuracao`, { ...config, feriados: novosFeriados });
      toast.success(`${novos.length} feriados adicionados!`);
    } catch (error) {
      toast.error('Erro ao guardar feriados');
    }
  };

  // Pausas
  const addPausa = async () => {
    if (!novaPausa.inicio || !novaPausa.fim) {
      toast.error('Preencha as horas da pausa');
      return;
    }
    const novasPausas = [...(config.pausas_adicionais || []), { ...novaPausa }];
    setConfig({
      ...config,
      pausas_adicionais: novasPausas
    });
    setNovaPausa({ inicio: '', fim: '', descricao: '' });
    
    // Guardar automaticamente
    try {
      await axios.put(`${API}/configuracao`, { ...config, pausas_adicionais: novasPausas });
      toast.success('Pausa adicionada!');
    } catch (error) {
      toast.error('Erro ao guardar pausa');
    }
  };

  const removePausa = async (index) => {
    const novasPausas = [...(config.pausas_adicionais || [])];
    novasPausas.splice(index, 1);
    setConfig({ ...config, pausas_adicionais: novasPausas });
    
    // Guardar automaticamente
    try {
      await axios.put(`${API}/configuracao`, { ...config, pausas_adicionais: novasPausas });
      toast.success('Pausa removida!');
    } catch (error) {
      toast.error('Erro ao remover pausa');
    }
  };

  // Calcular horas de trabalho diárias
  const calcularHorasTrabalho = () => {
    const [hi, mi] = config.horario_inicio.split(':').map(Number);
    const [hf, mf] = config.horario_fim.split(':').map(Number);
    const totalMinutos = (hf * 60 + mf) - (hi * 60 + mi);
    
    const [hai, mai] = config.intervalo_almoco_inicio.split(':').map(Number);
    const [haf, maf] = config.intervalo_almoco_fim.split(':').map(Number);
    const almocoMinutos = (haf * 60 + maf) - (hai * 60 + mai);
    
    const pausasMinutos = (config.pausas_adicionais || []).reduce((acc, p) => {
      if (p.inicio && p.fim) {
        const [pi, pmi] = p.inicio.split(':').map(Number);
        const [pf, pmf] = p.fim.split(':').map(Number);
        return acc + ((pf * 60 + pmf) - (pi * 60 + pmi));
      }
      return acc;
    }, 0);
    
    return totalMinutos - almocoMinutos - pausasMinutos; // Retorna minutos totais
  };

  // Formatar minutos para horas e minutos (ex: 528 min -> "8h 48min")
  const formatarHorasTrabalho = (minutosTotais) => {
    const horas = Math.floor(minutosTotais / 60);
    const minutos = minutosTotais % 60;
    if (minutos === 0) {
      return `${horas}h`;
    }
    return `${horas}h ${minutos}min`;
  };

  // === HANDLERS DE AUSÊNCIAS ===
  const calcularDiasUteis = (dataInicio, dataFim) => {
    if (!dataInicio || !dataFim) return 0;
    
    const inicio = new Date(dataInicio + 'T00:00:00');
    const fim = new Date(dataFim + 'T00:00:00');
    let dias = 0;
    const atual = new Date(inicio);
    
    const feriados = new Set((config.feriados || []).map(f => f.data));
    const diasTrabalho = config.dias_trabalho || [1, 2, 3, 4, 5];
    
    while (atual <= fim) {
      const diaSemana = atual.getDay();
      const dataStr = atual.toISOString().split('T')[0];
      
      // Só conta se for dia de trabalho E não for feriado
      if (diasTrabalho.includes(diaSemana) && !feriados.has(dataStr)) {
        dias++;
      }
      
      atual.setDate(atual.getDate() + 1);
    }
    
    return dias;
  };

  // === BALANÇO DE FÉRIAS ===
  const calcularBalancoOperadores = () => {
    const diasFeriasAnuais = config?.dias_ferias_anuais || 22;
    
    const balanco = operadores.map(op => {
      // Filtrar ausências do operador no ano atual
      const ausenciasOp = ausencias.filter(a => 
        a.operador_id === op.id && 
        a.estado === 'aprovado' &&
        new Date(a.data_inicio).getFullYear() === currentYear
      );
      
      // Calcular dias por tipo
      const diasPorTipo = {};
      tiposAusencia.forEach(t => diasPorTipo[t.id] = 0);
      
      ausenciasOp.forEach(a => {
        const dias = a.dias_uteis || calcularDiasUteis(a.data_inicio, a.data_fim);
        if (diasPorTipo[a.tipo] !== undefined) {
          diasPorTipo[a.tipo] += dias;
        }
      });
      
      const feriasPendentes = ausencias.filter(a => 
        a.operador_id === op.id && 
        a.tipo === 'ferias' &&
        a.estado === 'pendente' &&
        new Date(a.data_inicio).getFullYear() === currentYear
      ).reduce((acc, a) => acc + (a.dias_uteis || calcularDiasUteis(a.data_inicio, a.data_fim)), 0);
      
      return {
        operador: op,
        diasFeriasTotal: diasFeriasAnuais,
        diasFeriasUsados: diasPorTipo.ferias || 0,
        diasFeriasPendentes: feriasPendentes,
        diasFeriasDisponiveis: diasFeriasAnuais - (diasPorTipo.ferias || 0) - feriasPendentes,
        diasPorTipo,
        totalAusencias: ausenciasOp.length
      };
    });
    
    setBalancoOperadores(balanco);
    setShowBalancoDialog(true);
  };

  const handleSubmitAusencia = async (e) => {
    e.preventDefault();
    
    if (!formAusencia.operador_id || !formAusencia.data_inicio || !formAusencia.data_fim) {
      toast.error('Preencha todos os campos obrigatórios');
      return;
    }

    const diasUteis = calcularDiasUteis(formAusencia.data_inicio, formAusencia.data_fim);
    
    try {
      await axios.post(`${API}/ausencias`, {
        ...formAusencia,
        dias_uteis: diasUteis
      });
      toast.success(`Ausência registada com sucesso (${diasUteis} dias úteis)`);
      setShowFormAusencia(false);
      setFormAusencia({
        operador_id: '',
        data_inicio: '',
        data_fim: '',
        tipo: 'ferias',
        observacoes: ''
      });
      loadAllData();
    } catch (error) {
      toast.error('Erro ao registar ausência');
    }
  };

  const handleAprovarAusencia = async (ausenciaId) => {
    try {
      await axios.patch(`${API}/ausencias/${ausenciaId}/aprovar`);
      toast.success('Ausência aprovada');
      loadAllData();
    } catch (error) {
      toast.error('Erro ao aprovar ausência');
    }
  };

  const handleRejeitarAusencia = async (ausenciaId) => {
    try {
      await axios.patch(`${API}/ausencias/${ausenciaId}/rejeitar`);
      toast.success('Ausência rejeitada');
      loadAllData();
    } catch (error) {
      toast.error('Erro ao rejeitar ausência');
    }
  };

  const handleDeleteAusencia = async (ausenciaId) => {
    if (!window.confirm('Eliminar esta ausência?')) return;
    try {
      await axios.delete(`${API}/ausencias/${ausenciaId}`);
      toast.success('Ausência eliminada');
      loadAllData();
    } catch (error) {
      toast.error('Erro ao eliminar ausência');
    }
  };

  // === HANDLERS DE TIPOS DE AUSÊNCIA ===
  const handleSubmitTipo = async (e) => {
    e.preventDefault();
    
    if (!formTipo.nome.trim()) {
      toast.error('Nome do tipo é obrigatório');
      return;
    }

    const id = editingTipo?.id || formTipo.nome.toLowerCase().replace(/\s+/g, '_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const corConfig = CORES_DISPONIVEIS.find(c => c.cor === formTipo.cor) || CORES_DISPONIVEIS[0];
    
    const novoTipo = {
      id,
      nome: formTipo.nome,
      cor: corConfig.cor,
      corLight: corConfig.corLight,
      textColor: corConfig.textColor
    };

    try {
      if (editingTipo) {
        const novosTipos = tiposAusencia.map(t => t.id === editingTipo.id ? novoTipo : t);
        setTiposAusencia(novosTipos);
        await axios.put(`${API}/tipos-ausencia`, novosTipos).catch(() => {});
        toast.success('Tipo de ausência atualizado');
      } else {
        const novosTipos = [...tiposAusencia, novoTipo];
        setTiposAusencia(novosTipos);
        await axios.put(`${API}/tipos-ausencia`, novosTipos).catch(() => {});
        toast.success('Tipo de ausência criado');
      }
      
      setShowFormTipo(false);
      setEditingTipo(null);
      setFormTipo({ nome: '', cor: 'bg-blue-500', corLight: 'bg-blue-50', textColor: 'text-blue-600' });
    } catch (error) {
      toast.error('Erro ao guardar tipo de ausência');
    }
  };

  const handleEditTipo = (tipo) => {
    setEditingTipo(tipo);
    setFormTipo({
      nome: tipo.nome,
      cor: tipo.cor,
      corLight: tipo.corLight,
      textColor: tipo.textColor
    });
    setShowFormTipo(true);
  };

  const handleDeleteTipo = async (tipoId) => {
    const ausenciasComTipo = ausencias.filter(a => a.tipo === tipoId);
    if (ausenciasComTipo.length > 0) {
      toast.error(`Não é possível eliminar. Existem ${ausenciasComTipo.length} ausências com este tipo.`);
      return;
    }
    
    if (!window.confirm('Eliminar este tipo de ausência?')) return;
    
    const novosTipos = tiposAusencia.filter(t => t.id !== tipoId);
    setTiposAusencia(novosTipos);
    await axios.put(`${API}/tipos-ausencia`, novosTipos).catch(() => {});
    toast.success('Tipo de ausência eliminado');
  };

  // Helpers
  const getOperadorNome = (operadorId) => {
    const op = operadores.find(o => o.id === operadorId);
    return op?.nome_completo || 'N/A';
  };

  const getOperadorNomeAbreviado = (operadorId) => {
    const nome = getOperadorNome(operadorId);
    const partes = nome.split(' ');
    if (partes.length < 2) return nome;
    return `${partes[0]} ${partes[partes.length - 1]}`;
  };

  const getTipoConfig = (tipoId) => {
    return tiposAusencia.find(t => t.id === tipoId) || tiposAusencia[0] || {
      nome: 'Outro',
      cor: 'bg-gray-500',
      corLight: 'bg-gray-50',
      textColor: 'text-gray-600'
    };
  };

  // === CALENDÁRIO ===
  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDay = firstDay.getDay();
    return { daysInMonth, startingDay };
  };

  // Verifica se uma data é dia de trabalho
  const isDiaTrabalhoData = (dataStr) => {
    const date = new Date(dataStr + 'T00:00:00');
    const diaSemana = date.getDay();
    return (config.dias_trabalho || [1, 2, 3, 4, 5]).includes(diaSemana);
  };

  // Verifica se uma data é feriado
  const isFeriadoData = (dataStr) => {
    return (config.feriados || []).some(f => f.data === dataStr);
  };

  const getAusenciasForDay = (day, estado = 'aprovado') => {
    const dateStr = `${currentMonth.getFullYear()}-${String(currentMonth.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    
    // Não mostrar ausências em dias que não são de trabalho ou em feriados
    if (!isDiaTrabalhoData(dateStr) || isFeriadoData(dateStr)) {
      return [];
    }
    
    return ausencias.filter(a => {
      const inicio = a.data_inicio;
      const fim = a.data_fim;
      const matchData = dateStr >= inicio && dateStr <= fim;
      const matchEstado = estado === 'todos' || a.estado === estado;
      return matchData && matchEstado;
    });
  };

  const isDiaTrabalho = (day) => {
    if (!config?.dias_trabalho) return true;
    const date = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
    const diaSemana = date.getDay();
    return config.dias_trabalho.includes(diaSemana);
  };

  const getFeriado = (day) => {
    if (!config?.feriados) return null;
    const dateStr = `${currentMonth.getFullYear()}-${String(currentMonth.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    return config.feriados.find(f => f.data === dateStr);
  };

  const prevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const nextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };

  const goToToday = () => {
    setCurrentMonth(new Date());
  };

  const handleDayClick = (day) => {
    const dateStr = `${currentMonth.getFullYear()}-${String(currentMonth.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const ausenciasDia = getAusenciasForDay(day, 'todos');
    const feriado = getFeriado(day);
    const diaTrabalho = isDiaTrabalho(day);
    
    setSelectedDay({
      day,
      date: new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day),
      dateStr,
      ausencias: ausenciasDia,
      feriado,
      diaTrabalho
    });
    setShowDayDetail(true);
  };

  const { daysInMonth, startingDay } = getDaysInMonth(currentMonth);
  const pendentesCount = ausencias.filter(a => a.estado === 'pendente').length;
  const hoje = new Date().toISOString().split('T')[0];
  const ausentesHoje = ausencias.filter(a => 
    a.estado === 'aprovado' && 
    a.data_inicio <= hoje && 
    a.data_fim >= hoje &&
    isDiaTrabalhoData(hoje) &&
    !isFeriadoData(hoje)
  ).length;

  // Totais para o balanço
  const totalOperadores = operadores.length;
  // Leituras/Notificados por alerta
  const [leiturasMap, setLeiturasMap] = useState({});
  const [expandedAlerta, setExpandedAlerta] = useState(null);

  const fetchLeituras = async (alertaId) => {
    if (expandedAlerta === alertaId) {
      setExpandedAlerta(null);
      return;
    }
    try {
      const res = await axios.get(`${API}/alertas/${alertaId}/leituras`);
      setLeiturasMap(prev => ({ ...prev, [alertaId]: res.data }));
      setExpandedAlerta(alertaId);
    } catch {
      toast.error('Erro ao carregar leituras');
    }
  };

  const totalFeriasUsados = balancoOperadores.reduce((acc, b) => acc + b.diasFeriasUsados, 0);
  const totalFaltas = balancoOperadores.reduce((acc, b) => acc + (b.diasPorTipo?.falta || 0), 0);
  const totalBaixas = balancoOperadores.reduce((acc, b) => acc + (b.diasPorTipo?.baixa || 0), 0);

  if (loading) {
    return (
      <GestorLayout>
        <div className="flex items-center justify-center h-full">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
        </div>
      </GestorLayout>
    );
  }

  // === CRUD ALERTAS ===
  const salvarAlerta = async () => {
    setSaving(true);
    try {
      if (editandoAlerta) {
        await axios.put(`${API}/configuracoes/alertas/${editandoAlerta.id}`, novoAlerta);
        toast.success('Alerta atualizado!');
      } else {
        await axios.post(`${API}/configuracoes/alertas`, novoAlerta);
        toast.success('Alerta criado!');
      }
      loadAllData();
      setNovoAlerta({ titulo: '', mensagem: '', data_notificacao: '', destinatarios: 'todos', prioridade: 'normal' });
      setEditandoAlerta(null);
      setShowFormAlerta(false);
    } catch (error) {
      toast.error('Erro ao guardar alerta');
    }
    setSaving(false);
  };

  const eliminarAlerta = async (id) => {
    if (!window.confirm('Tem certeza que deseja eliminar este alerta?')) return;
    try {
      await axios.delete(`${API}/configuracoes/alertas/${id}`);
      toast.success('Alerta eliminado!');
      loadAllData();
    } catch (error) {
      toast.error('Erro ao eliminar alerta');
    }
  };

  const editarAlerta = (alerta) => {
    setNovoAlerta({
      titulo: alerta.titulo,
      mensagem: alerta.mensagem,
      data_notificacao: alerta.data_notificacao?.slice(0, 16) || '',
      destinatarios: alerta.destinatarios,
      prioridade: alerta.prioridade
    });
    setEditandoAlerta(alerta);
    setShowFormAlerta(true);
  };

  const clonarAlerta = (alerta) => {
    setNovoAlerta({
      titulo: alerta.titulo + ' (copia)',
      mensagem: alerta.mensagem,
      data_notificacao: '',
      destinatarios: alerta.destinatarios,
      prioridade: alerta.prioridade
    });
    setEditandoAlerta(null);
    setShowFormAlerta(true);
    toast.info('Alerta clonado - edite e guarde');
  };

  // === CRUD FRASES MOTIVACIONAIS ===
  const salvarFrase = async () => {
    setSaving(true);
    try {
      if (editandoFrase) {
        await axios.put(`${API}/configuracoes/frases-motivacionais/${editandoFrase.id}`, novaFrase);
        toast.success('Frase atualizada!');
      } else {
        await axios.post(`${API}/configuracoes/frases-motivacionais`, novaFrase);
        toast.success('Frase criada!');
      }
      loadAllData();
      setNovaFrase({ texto: '', ativa: true, mostrar_em: ['login', 'fim_tarefa'] });
      setEditandoFrase(null);
      setShowFormFrase(false);
    } catch (error) {
      toast.error('Erro ao guardar frase');
    }
    setSaving(false);
  };

  const eliminarFrase = async (id) => {
    if (!window.confirm('Tem certeza que deseja eliminar esta frase?')) return;
    try {
      await axios.delete(`${API}/configuracoes/frases-motivacionais/${id}`);
      toast.success('Frase eliminada!');
      loadAllData();
    } catch (error) {
      toast.error('Erro ao eliminar frase');
    }
  };

  const editarFrase = (frase) => {
    setNovaFrase({
      texto: frase.texto,
      ativa: frase.ativa,
      mostrar_em: frase.mostrar_em || ['login', 'fim_tarefa']
    });
    setEditandoFrase(frase);
    setShowFormFrase(true);
  };

  return (
    <GestorLayout>
      <div className="space-y-6" data-testid="configuracoes-page">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-heading font-bold text-stone-900 mb-2">Configurações</h1>
            <p className="text-stone-600">Configure horários, férias e ausências</p>
          </div>
          {activeTab === 'geral' && (
            <Button onClick={handleSaveConfigGeral} disabled={saving} data-testid="btn-save-config-geral">
              <Save className="h-4 w-4 mr-2" />
              {saving ? 'A guardar...' : 'Guardar Configurações'}
            </Button>
          )}
          {activeTab === 'horarios' && (
            <Button onClick={handleSaveConfig} disabled={saving} data-testid="btn-save-config">
              <Save className="h-4 w-4 mr-2" />
              {saving ? 'A guardar...' : 'Guardar Horários'}
            </Button>
          )}
        </div>

        {/* Tabs */}
        <div className="flex gap-2 border-b pb-0">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-t-lg font-medium transition-colors ${
                  activeTab === tab.id
                    ? 'bg-white text-primary border-x border-t'
                    : 'text-stone-500 hover:text-stone-700 hover:bg-stone-50'
                }`}
                data-testid={`tab-${tab.id}`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            );
          })}
        </div>

        {/* Tab Geral */}
        {activeTab === 'geral' && (
          <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Fuso Horário */}
              <Card className="p-6">
                <div className="flex items-center gap-3 mb-6">
                  <Clock className="h-5 w-5 text-primary" />
                  <h2 className="text-xl font-heading font-bold text-stone-900">Fuso Horário</h2>
                </div>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-stone-700 mb-2">
                      Fuso Horário do Sistema
                    </label>
                    <select
                      value={configGeral.timezone}
                      onChange={(e) => { setConfigGeral({ ...configGeral, timezone: e.target.value }); markDirty(); }}
                      className="w-full h-10 px-3 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                      data-testid="timezone-select"
                    >
                      {TIMEZONES.map((tz) => (
                        <option key={tz.value} value={tz.value}>
                          {tz.label}
                        </option>
                      ))}
                    </select>
                    <p className="mt-2 text-xs text-stone-500">
                      Este fuso horário será usado para exibir todas as datas e horas no sistema.
                    </p>
                  </div>
                  
                  {/* Preview da hora actual */}
                  <div className="bg-stone-50 rounded-lg p-4">
                    <p className="text-sm text-stone-600 mb-1">Hora actual no fuso seleccionado:</p>
                    <p className="text-2xl font-mono font-bold text-stone-900">
                      {new Date().toLocaleString(configGeral.formato_hora === '12h' ? 'en-US' : 'pt-PT', { 
                        timeZone: configGeral.timezone,
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: configGeral.formato_hora === '12h'
                      })}
                    </p>
                    <p className="text-sm text-stone-500 mt-1">
                      {(() => {
                        const d = new Date();
                        if (configGeral.formato_data === 'yyyy-MM-dd') {
                          return d.toLocaleString('sv-SE', { 
                            timeZone: configGeral.timezone,
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          });
                        }
                        return d.toLocaleString('pt-PT', { 
                          timeZone: configGeral.timezone,
                          weekday: 'long',
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric'
                        });
                      })()}
                    </p>
                  </div>
                </div>
              </Card>
              
              {/* Formato de Data e Hora */}
              <Card className="p-6">
                <div className="flex items-center gap-3 mb-6">
                  <Calendar className="h-5 w-5 text-primary" />
                  <h2 className="text-xl font-heading font-bold text-stone-900">Formatos</h2>
                </div>
                
                <div className="space-y-6">
                  {/* Formato de Data */}
                  <div>
                    <label className="block text-sm font-medium text-stone-700 mb-2">
                      Formato de Data
                    </label>
                    <div className="space-y-2">
                      <label className="flex items-center gap-3 p-3 border border-stone-200 rounded-lg hover:bg-stone-50 cursor-pointer">
                        <input
                          type="radio"
                          name="formato_data"
                          value="dd/MM/yyyy"
                          checked={configGeral.formato_data === 'dd/MM/yyyy'}
                          onChange={(e) => { setConfigGeral({ ...configGeral, formato_data: e.target.value }); markDirty(); }}
                          className="h-4 w-4 text-primary"
                          data-testid="formato-data-ddmmyyyy"
                        />
                        <div>
                          <span className="font-medium">DD/MM/AAAA</span>
                          <span className="text-stone-500 ml-2 text-sm">Ex: 31/03/2026</span>
                        </div>
                      </label>
                      <label className="flex items-center gap-3 p-3 border border-stone-200 rounded-lg hover:bg-stone-50 cursor-pointer">
                        <input
                          type="radio"
                          name="formato_data"
                          value="yyyy-MM-dd"
                          checked={configGeral.formato_data === 'yyyy-MM-dd'}
                          onChange={(e) => { setConfigGeral({ ...configGeral, formato_data: e.target.value }); markDirty(); }}
                          className="h-4 w-4 text-primary"
                          data-testid="formato-data-yyyymmdd"
                        />
                        <div>
                          <span className="font-medium">AAAA-MM-DD</span>
                          <span className="text-stone-500 ml-2 text-sm">Ex: 2026-03-31</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  
                  {/* Formato de Hora */}
                  <div>
                    <label className="block text-sm font-medium text-stone-700 mb-2">
                      Formato de Hora
                    </label>
                    <div className="space-y-2">
                      <label className="flex items-center gap-3 p-3 border border-stone-200 rounded-lg hover:bg-stone-50 cursor-pointer">
                        <input
                          type="radio"
                          name="formato_hora"
                          value="24h"
                          checked={configGeral.formato_hora === '24h'}
                          onChange={(e) => { setConfigGeral({ ...configGeral, formato_hora: e.target.value }); markDirty(); }}
                          className="h-4 w-4 text-primary"
                          data-testid="formato-hora-24h"
                        />
                        <div>
                          <span className="font-medium">24 horas</span>
                          <span className="text-stone-500 ml-2 text-sm">Ex: 14:30</span>
                        </div>
                      </label>
                      <label className="flex items-center gap-3 p-3 border border-stone-200 rounded-lg hover:bg-stone-50 cursor-pointer">
                        <input
                          type="radio"
                          name="formato_hora"
                          value="12h"
                          checked={configGeral.formato_hora === '12h'}
                          onChange={(e) => { setConfigGeral({ ...configGeral, formato_hora: e.target.value }); markDirty(); }}
                          className="h-4 w-4 text-primary"
                          data-testid="formato-hora-12h"
                        />
                        <div>
                          <span className="font-medium">12 horas (AM/PM)</span>
                          <span className="text-stone-500 ml-2 text-sm">Ex: 2:30 PM</span>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            
            {/* Segunda linha - Informações */}
            <div className="mt-6">
              {/* Informações do Sistema */}
              <Card className="p-6">
                <div className="flex items-center gap-3 mb-6">
                  <Settings className="h-5 w-5 text-primary" />
                  <h2 className="text-xl font-heading font-bold text-stone-900">Informações</h2>
                </div>
                
                <div className="space-y-4">
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <p className="text-sm text-blue-800">
                      <strong>Nota:</strong> As alterações de fuso horário e formatos afectam a exibição de todas as datas e horas no sistema, incluindo:
                    </p>
                    <ul className="text-sm text-blue-700 mt-2 list-disc list-inside space-y-1">
                      <li>Registos de produção</li>
                      <li>Horas de início e fim de tarefas</li>
                      <li>Relatórios e estatísticas</li>
                      <li>Alertas e notificações</li>
                    </ul>
                  </div>
                  
                  <div className="text-sm text-stone-600">
                    <p><strong>Fuso horário do servidor:</strong> UTC</p>
                    <p className="mt-1"><strong>Armazenamento:</strong> Todas as datas são guardadas em UTC</p>
                  </div>
                </div>
              </Card>
            </div>
          </>
        )}

        {/* Tab Horários */}
        {activeTab === 'horarios' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Horário de Trabalho */}
            <Card className="p-6">
              <div className="flex items-center gap-3 mb-6">
                <Clock className="h-5 w-5 text-primary" />
                <h2 className="text-xl font-heading font-bold text-stone-900">Horário de Trabalho</h2>
              </div>
              
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-1">Início do Expediente</label>
                  <Input
                    type="time"
                    value={config.horario_inicio}
                    onChange={(e) => { setConfig({ ...config, horario_inicio: e.target.value }); markDirty(); }}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-1">Fim do Expediente</label>
                  <Input
                    type="time"
                    value={config.horario_fim}
                    onChange={(e) => { setConfig({ ...config, horario_fim: e.target.value }); markDirty(); }}
                  />
                </div>
              </div>

              <div className="flex items-center gap-3 mb-4">
                <Coffee className="h-5 w-5 text-amber-600" />
                <h3 className="text-lg font-semibold text-stone-900">Intervalo de Almoço</h3>
              </div>
              
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-1">Início</label>
                  <Input
                    type="time"
                    value={config.intervalo_almoco_inicio}
                    onChange={(e) => { setConfig({ ...config, intervalo_almoco_inicio: e.target.value }); markDirty(); }}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-1">Fim</label>
                  <Input
                    type="time"
                    value={config.intervalo_almoco_fim}
                    onChange={(e) => { setConfig({ ...config, intervalo_almoco_fim: e.target.value }); markDirty(); }}
                  />
                </div>
              </div>

              {/* Pausas adicionais */}
              <div className="flex items-center gap-3 mb-4">
                <Sun className="h-5 w-5 text-orange-500" />
                <h3 className="text-lg font-semibold text-stone-900">Pausas Adicionais</h3>
              </div>
              
              <div className="space-y-2 mb-4">
                {(config.pausas_adicionais || []).map((pausa, idx) => (
                  <div key={idx} className="flex items-center gap-2 bg-stone-50 p-2 rounded">
                    <span className="text-sm text-stone-600">{pausa.inicio} - {pausa.fim}</span>
                    {pausa.descricao && <span className="text-sm text-stone-500">({pausa.descricao})</span>}
                    <Button variant="ghost" size="icon" className="h-6 w-6 ml-auto" onClick={() => removePausa(idx)}>
                      <Trash2 className="h-3 w-3 text-red-500" />
                    </Button>
                  </div>
                ))}
              </div>
              
              <div className="flex gap-2">
                <Input
                  type="time"
                  placeholder="Início"
                  value={novaPausa.inicio}
                  onChange={(e) => setNovaPausa({ ...novaPausa, inicio: e.target.value })}
                  className="w-24"
                />
                <Input
                  type="time"
                  placeholder="Fim"
                  value={novaPausa.fim}
                  onChange={(e) => setNovaPausa({ ...novaPausa, fim: e.target.value })}
                  className="w-24"
                />
                <Input
                  placeholder="Descrição"
                  value={novaPausa.descricao}
                  onChange={(e) => setNovaPausa({ ...novaPausa, descricao: e.target.value })}
                  className="flex-1"
                />
                <Button variant="outline" size="icon" onClick={addPausa}>
                  <Plus className="h-4 w-4" />
                </Button>
              </div>

              {/* Resumo */}
              <div className="mt-6 p-4 bg-primary/5 rounded-lg">
                <div className="text-center">
                  <p className="text-sm text-stone-500">Horas de trabalho diárias</p>
                  <p className="text-3xl font-bold text-primary">{formatarHorasTrabalho(calcularHorasTrabalho())}</p>
                </div>
              </div>
            </Card>

            {/* Coluna direita */}
            <div className="space-y-6">
              {/* Dias de Trabalho */}
              <Card className="p-6">
                <div className="flex items-center gap-3 mb-6">
                  <Sun className="h-5 w-5 text-amber-500" />
                  <h2 className="text-xl font-heading font-bold text-stone-900">Dias de Trabalho</h2>
                </div>
                
                <div className="flex flex-wrap gap-2">
                  {DIAS_SEMANA.map((dia) => (
                    <button
                      key={dia.valor}
                      onClick={() => toggleDiaTrabalho(dia.valor)}
                      className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                        config.dias_trabalho.includes(dia.valor)
                          ? 'bg-primary text-white'
                          : 'bg-stone-100 text-stone-500 hover:bg-stone-200'
                      }`}
                    >
                      {dia.abrev}
                    </button>
                  ))}
                </div>
                
                <p className="mt-4 text-sm text-stone-500">
                  {config.dias_trabalho.length} dias de trabalho por semana ({formatarHorasTrabalho(config.dias_trabalho.length * calcularHorasTrabalho())} semanais)
                </p>
              </Card>

              {/* Feriados */}
              <Card className="p-6">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <Calendar className="h-5 w-5 text-red-500" />
                    <h2 className="text-xl font-heading font-bold text-stone-900">Feriados</h2>
                  </div>
                  <Button variant="outline" size="sm" onClick={loadFeriadosPortugal}>
                    Carregar Feriados PT
                  </Button>
                </div>
                
                <div className="max-h-48 overflow-y-auto mb-4 space-y-1">
                  {(config.feriados || []).slice(0, 20).map((feriado) => (
                    <div key={feriado.data} className="flex items-center justify-between p-2 bg-stone-50 rounded">
                      <div>
                        <span className="text-sm font-medium text-stone-700">{new Date(feriado.data + 'T00:00:00').toLocaleDateString('pt-PT')}</span>
                        <span className="text-sm text-stone-500 ml-2">{feriado.nome}</span>
                      </div>
                      <Button variant="ghost" size="icon" className="h-6 w-6" onClick={() => removeFeriado(feriado.data)}>
                        <Trash2 className="h-3 w-3 text-red-500" />
                      </Button>
                    </div>
                  ))}
                </div>
                
                <div className="flex gap-2">
                  <Input
                    type="date"
                    value={novoFeriado.data}
                    onChange={(e) => setNovoFeriado({ ...novoFeriado, data: e.target.value })}
                    className="w-40"
                  />
                  <Input
                    placeholder="Nome do feriado"
                    value={novoFeriado.nome}
                    onChange={(e) => setNovoFeriado({ ...novoFeriado, nome: e.target.value })}
                    className="flex-1"
                  />
                  <Button variant="outline" size="icon" onClick={addFeriado}>
                    <Plus className="h-4 w-4" />
                  </Button>
                </div>
              </Card>

              {/* Dias de férias anuais */}
              <Card className="p-6">
                <div className="flex items-center gap-3 mb-4">
                  <Palmtree className="h-5 w-5 text-blue-500" />
                  <h2 className="text-xl font-heading font-bold text-stone-900">Férias Anuais</h2>
                </div>
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-1">Dias de férias por funcionário/ano</label>
                  <Input
                    type="number"
                    min="0"
                    max="60"
                    value={config.dias_ferias_anuais || 22}
                    onChange={(e) => { setConfig({ ...config, dias_ferias_anuais: parseInt(e.target.value) || 22 }); markDirty(); }}
                    className="w-24"
                  />
                </div>
              </Card>
            </div>
          </div>
        )}

        {/* Tab Férias */}
        {activeTab === 'ferias' && (
          <div className="space-y-6">
            {/* Header com estatísticas e botões */}
            <Card className="p-4">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-4">
                  <h2 className="text-xl font-heading font-bold text-stone-900">
                    Ausências ({ausencias.length})
                  </h2>
                  {pendentesCount > 0 && (
                    <button
                      onClick={() => {
                        setFiltroEstadoAusencia(filtroEstadoAusencia === 'pendente' ? '' : 'pendente');
                        setViewMode('lista');
                      }}
                      className={`px-3 py-1 rounded-full text-sm font-medium cursor-pointer transition-all hover:scale-105 ${
                        filtroEstadoAusencia === 'pendente' 
                          ? 'bg-amber-500 text-white' 
                          : 'bg-amber-100 text-amber-700'
                      }`}
                      data-testid="btn-filtro-pendentes"
                    >
                      {pendentesCount} pendente{pendentesCount > 1 ? 's' : ''} - aprovar
                    </button>
                  )}
                  {ausentesHoje > 0 && (
                    <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                      {ausentesHoje} ausente{ausentesHoje > 1 ? 's' : ''} hoje
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex border rounded-lg overflow-hidden">
                    <button
                      onClick={() => setViewMode('calendario')}
                      className={`p-2 ${viewMode === 'calendario' ? 'bg-primary text-white' : 'bg-white text-stone-500 hover:bg-stone-50'}`}
                    >
                      <Grid className="h-4 w-4" />
                    </button>
                    <button
                      onClick={() => setViewMode('lista')}
                      className={`p-2 ${viewMode === 'lista' ? 'bg-primary text-white' : 'bg-white text-stone-500 hover:bg-stone-50'}`}
                    >
                      <List className="h-4 w-4" />
                    </button>
                  </div>
                  <Button variant="outline" onClick={calcularBalancoOperadores}>
                    <BarChart3 className="h-4 w-4 mr-2" />
                    Balanço
                  </Button>
                  <Button variant="outline" onClick={() => setShowFormTipo(true)}>
                    <Settings className="h-4 w-4 mr-2" />
                    Tipos
                  </Button>
                  <Button onClick={() => setShowFormAusencia(true)} className="rounded-full">
                    <Plus className="h-4 w-4 mr-2" />
                    Nova Ausência
                  </Button>
                </div>
              </div>
            </Card>

            {/* Vista Calendário */}
            {viewMode === 'calendario' && (
              <Card className="p-6">
                {/* Header do calendário */}
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-2">
                    <Button variant="outline" size="icon" onClick={prevMonth}>
                      <ChevronLeft className="h-4 w-4" />
                    </Button>
                    <Button variant="outline" size="icon" onClick={nextMonth}>
                      <ChevronRight className="h-4 w-4" />
                    </Button>
                    <h3 className="text-xl font-heading font-bold text-stone-900 ml-2">
                      {currentMonth.toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' })}
                    </h3>
                  </div>
                  <Button variant="ghost" onClick={goToToday}>Hoje</Button>
                </div>

                {/* Cabeçalho dos dias da semana */}
                <div className="grid grid-cols-7 gap-1 mb-2">
                  {['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'].map((dia, idx) => {
                    const isDiaConfig = config?.dias_trabalho?.includes(idx);
                    return (
                      <div 
                        key={dia} 
                        className={`text-center text-sm font-medium py-2 rounded ${
                          isDiaConfig !== false ? 'text-stone-700' : 'text-stone-400'
                        }`}
                      >
                        {dia}
                      </div>
                    );
                  })}
                </div>

                {/* Grid do calendário */}
                <div className="grid grid-cols-7 gap-1">
                  {/* Células vazias para os dias antes do mês começar */}
                  {Array.from({ length: startingDay }).map((_, i) => (
                    <div key={`empty-${i}`} className="h-28 bg-stone-50/50 rounded-lg" />
                  ))}
                  
                  {/* Dias do mês */}
                  {Array.from({ length: daysInMonth }).map((_, i) => {
                    const day = i + 1;
                    const ausenciasDia = getAusenciasForDay(day);
                    const isToday = new Date().toDateString() === new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day).toDateString();
                    const feriado = getFeriado(day);
                    const diaTrabalho = isDiaTrabalho(day);
                    const isWeekend = !diaTrabalho;
                    
                    return (
                      <div 
                        key={day} 
                        onClick={() => handleDayClick(day)}
                        className={`h-28 p-2 rounded-lg border transition-all cursor-pointer hover:shadow-md ${
                          isToday ? 'border-primary border-2 bg-primary/5' : 
                          feriado ? 'border-amber-300 bg-amber-50' :
                          isWeekend ? 'border-stone-100 bg-stone-50' :
                          'border-stone-200 bg-white hover:border-stone-300'
                        }`}
                        data-testid={`day-${day}`}
                      >
                        <div className="flex items-center justify-between">
                          <span className={`text-sm font-medium ${
                            isToday ? 'text-primary' : 
                            feriado ? 'text-amber-700' :
                            isWeekend ? 'text-stone-400' :
                            'text-stone-700'
                          }`}>
                            {day}
                          </span>
                          {feriado && (
                            <span className="text-[10px] text-amber-600 font-medium truncate max-w-[60px]" title={feriado.nome}>
                              {feriado.nome.split(' ')[0]}
                            </span>
                          )}
                        </div>
                        <div className="mt-1 space-y-0.5 overflow-y-auto max-h-[70px]">
                          {ausenciasDia.slice(0, 3).map((a) => {
                            const tipoConfig = getTipoConfig(a.tipo);
                            return (
                              <div 
                                key={a.id} 
                                className={`text-[11px] px-1.5 py-0.5 rounded ${tipoConfig.corLight} ${tipoConfig.textColor} truncate font-medium`}
                                title={`${getOperadorNome(a.operador_id)} - ${tipoConfig.nome}`}
                              >
                                {getOperadorNomeAbreviado(a.operador_id)}
                              </div>
                            );
                          })}
                          {ausenciasDia.length > 3 && (
                            <span className="text-[10px] text-stone-500 font-medium">+{ausenciasDia.length - 3} mais</span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Legenda */}
                <div className="flex flex-wrap gap-4 mt-6 pt-4 border-t">
                  {tiposAusencia.map((tipo) => (
                    <div key={tipo.id} className="flex items-center gap-2">
                      <div className={`w-3 h-3 rounded ${tipo.cor}`}></div>
                      <span className="text-sm text-stone-600">{tipo.nome}</span>
                    </div>
                  ))}
                  <div className="flex items-center gap-2 ml-4 pl-4 border-l">
                    <div className="w-3 h-3 rounded bg-amber-400"></div>
                    <span className="text-sm text-stone-600">Feriado</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded bg-stone-300"></div>
                    <span className="text-sm text-stone-600">Fim de Semana</span>
                  </div>
                </div>
              </Card>
            )}

            {/* Vista Lista */}
            {viewMode === 'lista' && (
              <Card className="p-6">
                {/* Filtros */}
                <div className="flex gap-4 mb-4">
                  <select
                    value={filtroEstadoAusencia}
                    onChange={(e) => setFiltroEstadoAusencia(e.target.value)}
                    className="px-3 py-2 border border-stone-300 rounded-lg text-sm"
                  >
                    <option value="">Todos os estados</option>
                    <option value="pendente">Pendentes</option>
                    <option value="aprovado">Aprovados</option>
                    <option value="rejeitado">Rejeitados</option>
                  </select>
                </div>

                {/* Lista de ausências */}
                {ausencias.length === 0 ? (
                  <div className="text-center py-8 text-stone-500">
                    Nenhuma ausência registada
                  </div>
                ) : (
                  <div className="space-y-3 max-h-[500px] overflow-y-auto">
                    {ausencias
                      .filter(a => !filtroEstadoAusencia || a.estado === filtroEstadoAusencia)
                      .sort((a, b) => new Date(b.data_inicio) - new Date(a.data_inicio))
                      .map((ausencia) => {
                        const tipoConfig = getTipoConfig(ausencia.tipo);
                        const estadoConfig = ESTADO_AUSENCIA[ausencia.estado] || ESTADO_AUSENCIA.pendente;
                        
                        return (
                          <div 
                            key={ausencia.id}
                            className={`flex items-center justify-between p-4 rounded-lg border ${tipoConfig.corLight}`}
                          >
                            <div className="flex items-center gap-4">
                              <div className={`p-2 rounded-full ${tipoConfig.cor} text-white`}>
                                <User className="h-5 w-5" />
                              </div>
                              <div>
                                <p className="font-medium text-stone-900">
                                  {getOperadorNome(ausencia.operador_id)}
                                </p>
                                <p className="text-sm text-stone-600">
                                  {new Date(ausencia.data_inicio + 'T00:00:00').toLocaleDateString('pt-PT')} 
                                  {ausencia.data_inicio !== ausencia.data_fim && 
                                    ` - ${new Date(ausencia.data_fim + 'T00:00:00').toLocaleDateString('pt-PT')}`
                                  }
                                  <span className="ml-2 text-stone-500">
                                    ({ausencia.dias_uteis || 1} dia{(ausencia.dias_uteis || 1) > 1 ? 's úteis' : ' útil'})
                                  </span>
                                </p>
                                <p className="text-xs text-stone-500 mt-1">
                                  <span className={`${tipoConfig.textColor} font-medium`}>{tipoConfig.nome}</span>
                                  {ausencia.observacoes && ` • ${ausencia.observacoes}`}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center gap-3">
                              <span className={`px-2 py-1 rounded-full text-xs text-white ${estadoConfig.color}`}>
                                {estadoConfig.label}
                              </span>
                              {ausencia.estado === 'pendente' && (
                                <div className="flex gap-1">
                                  <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={() => handleAprovarAusencia(ausencia.id)}
                                    className="h-8 w-8 text-green-600 hover:bg-green-50"
                                  >
                                    <Check className="h-4 w-4" />
                                  </Button>
                                  <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={() => handleRejeitarAusencia(ausencia.id)}
                                    className="h-8 w-8 text-red-600 hover:bg-red-50"
                                  >
                                    <X className="h-4 w-4" />
                                  </Button>
                                </div>
                              )}
                              <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => handleDeleteAusencia(ausencia.id)}
                                className="h-8 w-8 text-stone-400 hover:text-red-500"
                              >
                                <Trash2 className="h-4 w-4" />
                              </Button>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </Card>
            )}
          </div>
        )}

        {/* Tab Alertas */}
        {activeTab === 'alertas' && (
          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-heading font-bold">Alertas</h2>
              <Button onClick={() => { setShowFormAlerta(true); setEditandoAlerta(null); setNovoAlerta({ titulo: '', mensagem: '', data_notificacao: '', destinatarios: 'todos', prioridade: 'normal' }); }}>
                <Plus className="h-4 w-4 mr-2" /> Novo Alerta
              </Button>
            </div>
            
            {showFormAlerta && (
              <Card className="p-6">
                <h3 className="font-semibold mb-4">{editandoAlerta ? 'Editar Alerta' : 'Novo Alerta'}</h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-stone-700 mb-1">Título *</label>
                    <Input value={novoAlerta.titulo} onChange={(e) => setNovoAlerta({...novoAlerta, titulo: e.target.value})} placeholder="Título do alerta" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-stone-700 mb-1">Mensagem *</label>
                    <textarea className="w-full border rounded-lg p-2 min-h-[80px]" value={novoAlerta.mensagem} onChange={(e) => setNovoAlerta({...novoAlerta, mensagem: e.target.value})} placeholder="Mensagem do alerta" />
                  </div>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-stone-700 mb-1">Data/Hora</label>
                      <Input type="datetime-local" value={novoAlerta.data_notificacao} onChange={(e) => setNovoAlerta({...novoAlerta, data_notificacao: e.target.value})} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-stone-700 mb-1">Destinatários</label>
                      <select className="w-full border rounded-lg p-2" value={novoAlerta.destinatarios} onChange={(e) => setNovoAlerta({...novoAlerta, destinatarios: e.target.value})}>
                        <option value="todos">Todos</option>
                        <option value="gestores">Gestores</option>
                        <option value="operadores">Operadores</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-stone-700 mb-1">Prioridade</label>
                      <select className="w-full border rounded-lg p-2" value={novoAlerta.prioridade} onChange={(e) => setNovoAlerta({...novoAlerta, prioridade: e.target.value})}>
                        <option value="baixa">Baixa</option>
                        <option value="normal">Normal</option>
                        <option value="alta">Alta</option>
                      </select>
                    </div>
                  </div>
                  <div className="flex justify-end gap-2">
                    <Button variant="outline" onClick={() => setShowFormAlerta(false)}>Cancelar</Button>
                    <Button onClick={salvarAlerta} disabled={!novoAlerta.titulo || !novoAlerta.mensagem || saving}>
                      {saving ? 'A guardar...' : 'Guardar'}
                    </Button>
                  </div>
                </div>
              </Card>
            )}
            
            {/* Alertas do Gestor (manuais) */}
            <div>
              <h3 className="text-sm font-semibold text-stone-500 uppercase tracking-wide mb-3 flex items-center gap-2">
                <User className="h-4 w-4" />
                Alertas do Gestor
              </h3>
              <div className="space-y-3">
                {alertas.filter(a => a.tipo === 'gestor' || !a.tipo).length === 0 ? (
                  <Card className="p-6 text-center text-stone-400 border-dashed">
                    <Bell className="h-8 w-8 mx-auto mb-2 opacity-30" />
                    <p className="text-sm">Nenhum alerta manual criado</p>
                  </Card>
                ) : (
                  alertas.filter(a => a.tipo === 'gestor' || !a.tipo).map((alerta) => (
                    <Card key={alerta.id} className={`p-4 ${alerta.prioridade === 'alta' ? 'border-l-4 border-l-red-500' : alerta.prioridade === 'normal' ? 'border-l-4 border-l-amber-500' : ''}`}>
                      <div className="flex justify-between items-start">
                        <div className="flex-1 min-w-0">
                          <h4 className="font-semibold flex items-center gap-2">
                            <Bell className="h-4 w-4" />
                            {alerta.titulo}
                            <span className={`text-xs px-2 py-0.5 rounded-full ${alerta.prioridade === 'alta' ? 'bg-red-100 text-red-600' : alerta.prioridade === 'normal' ? 'bg-amber-100 text-amber-600' : 'bg-stone-100 text-stone-600'}`}>
                              {alerta.prioridade}
                            </span>
                          </h4>
                          <p className="text-stone-600 mt-1">{alerta.mensagem}</p>
                          <p className="text-xs text-stone-400 mt-2">
                            {alerta.data_notificacao && `Notificar: ${new Date(alerta.data_notificacao).toLocaleString('pt-PT')}`} | Dest: {alerta.destinatarios}
                          </p>
                          {/* Botao Notificados */}
                          <button
                            onClick={() => fetchLeituras(alerta.id)}
                            className="mt-2 text-xs font-semibold flex items-center gap-1 px-2 py-1 rounded-md hover:bg-stone-100 transition-colors"
                            style={{ color: '#0B3B30' }}
                            data-testid={`btn-notificados-${alerta.id}`}
                          >
                            <CheckCircle2 className="h-3.5 w-3.5" />
                            {expandedAlerta === alerta.id ? 'Fechar' : 'Ver notificados'}
                            {leiturasMap[alerta.id] && ` (${leiturasMap[alerta.id].total})`}
                          </button>
                          {/* Lista de notificados expandida */}
                          {expandedAlerta === alerta.id && leiturasMap[alerta.id] && (
                            <div className="mt-2 p-2 bg-green-50 rounded-lg border border-green-200">
                              <p className="text-xs font-bold text-green-700 mb-1">
                                {leiturasMap[alerta.id].total} operador(es) notificado(s):
                              </p>
                              {leiturasMap[alerta.id].leituras.length === 0 ? (
                                <p className="text-xs text-stone-400 italic">Nenhum operador confirmou ainda</p>
                              ) : (
                                <div className="space-y-1">
                                  {leiturasMap[alerta.id].leituras.map((l, idx) => (
                                    <div key={idx} className="flex items-center gap-2 text-xs">
                                      <CheckCircle2 className="h-3 w-3 text-green-600 flex-shrink-0" />
                                      <span className="font-medium text-stone-700">{l.nome}</span>
                                      <span className="text-stone-400">@{l.username}</span>
                                      <span className="text-stone-400 ml-auto">{l.lido_em ? new Date(l.lido_em).toLocaleString('pt-PT') : ''}</span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div className="flex gap-1 flex-shrink-0">
                          <Button variant="ghost" size="sm" onClick={() => clonarAlerta(alerta)} title="Clonar"><Copy className="h-4 w-4" /></Button>
                          <Button variant="ghost" size="sm" onClick={() => editarAlerta(alerta)}><Edit className="h-4 w-4" /></Button>
                          <Button variant="ghost" size="sm" onClick={() => eliminarAlerta(alerta.id)} className="text-red-500"><Trash2 className="h-4 w-4" /></Button>
                        </div>
                      </div>
                    </Card>
                  ))
                )}
              </div>
            </div>
            
            {/* Alertas do Sistema (automáticos) */}
            {alertas.filter(a => a.tipo === 'sistema').length > 0 && (
              <div>
                <h3 className="text-sm font-semibold text-stone-500 uppercase tracking-wide mb-3 flex items-center gap-2">
                  <Settings className="h-4 w-4" />
                  Alertas Automáticos do Sistema
                </h3>
                <div className="space-y-3">
                  {alertas.filter(a => a.tipo === 'sistema').map((alerta) => (
                    <Card key={alerta.id} className="p-4 bg-blue-50/50 border-blue-200">
                      <div className="flex justify-between items-start">
                        <div>
                          <h4 className="font-semibold flex items-center gap-2 text-blue-800">
                            <Settings className="h-4 w-4" />
                            {alerta.titulo}
                            <span className="text-xs px-2 py-0.5 rounded-full bg-blue-100 text-blue-600">
                              automático
                            </span>
                          </h4>
                          <p className="text-blue-700 mt-1">{alerta.mensagem}</p>
                          <p className="text-xs text-blue-400 mt-2">
                            {alerta.data_notificacao && `Criado: ${new Date(alerta.data_notificacao).toLocaleString('pt-PT')}`} | Dest: {alerta.destinatarios}
                          </p>
                        </div>
                        <Button variant="ghost" size="sm" onClick={() => eliminarAlerta(alerta.id)} className="text-red-500"><Trash2 className="h-4 w-4" /></Button>
                      </div>
                    </Card>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Tab Frases Motivacionais */}
        {activeTab === 'frases' && (
          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-heading font-bold">Frases Motivacionais</h2>
              <Button onClick={() => { setShowFormFrase(true); setEditandoFrase(null); setNovaFrase({ texto: '', ativa: true, mostrar_em: ['login', 'fim_tarefa'] }); }}>
                <Plus className="h-4 w-4 mr-2" /> Nova Frase
              </Button>
            </div>
            
            {showFormFrase && (
              <Card className="p-6">
                <h3 className="font-semibold mb-4">{editandoFrase ? 'Editar Frase' : 'Nova Frase'}</h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-stone-700 mb-1">Texto da frase *</label>
                    <textarea className="w-full border rounded-lg p-2 min-h-[80px]" value={novaFrase.texto} onChange={(e) => setNovaFrase({...novaFrase, texto: e.target.value})} placeholder="Digite a frase motivacional" />
                  </div>
                  <div className="flex items-center gap-6">
                    <label className="flex items-center gap-2">
                      <input type="checkbox" checked={novaFrase.ativa} onChange={(e) => setNovaFrase({...novaFrase, ativa: e.target.checked})} className="rounded" />
                      <span className="text-sm">Frase ativa</span>
                    </label>
                    <label className="flex items-center gap-2">
                      <input type="checkbox" checked={novaFrase.mostrar_em?.includes('login')} onChange={(e) => setNovaFrase({...novaFrase, mostrar_em: e.target.checked ? [...(novaFrase.mostrar_em || []), 'login'] : (novaFrase.mostrar_em || []).filter(m => m !== 'login')})} className="rounded" />
                      <span className="text-sm">Mostrar no login</span>
                    </label>
                    <label className="flex items-center gap-2">
                      <input type="checkbox" checked={novaFrase.mostrar_em?.includes('fim_tarefa')} onChange={(e) => setNovaFrase({...novaFrase, mostrar_em: e.target.checked ? [...(novaFrase.mostrar_em || []), 'fim_tarefa'] : (novaFrase.mostrar_em || []).filter(m => m !== 'fim_tarefa')})} className="rounded" />
                      <span className="text-sm">Mostrar no fim de tarefa</span>
                    </label>
                  </div>
                  <div className="flex justify-end gap-2">
                    <Button variant="outline" onClick={() => setShowFormFrase(false)}>Cancelar</Button>
                    <Button onClick={salvarFrase} disabled={!novaFrase.texto || saving}>
                      {saving ? 'A guardar...' : 'Guardar'}
                    </Button>
                  </div>
                </div>
              </Card>
            )}
            
            <div className="space-y-3">
              {frases.length === 0 ? (
                <Card className="p-8 text-center text-stone-500">
                  <MessageSquareQuote className="h-12 w-12 mx-auto mb-4 opacity-30" />
                  <p>Nenhuma frase criada</p>
                </Card>
              ) : (
                frases.map((frase) => (
                  <Card key={frase.id} className={`p-4 ${!frase.ativa ? 'opacity-50' : ''}`}>
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="text-lg italic">"{frase.texto}"</p>
                        <div className="flex gap-2 mt-2">
                          {frase.ativa ? (
                            <span className="text-xs bg-green-100 text-green-600 px-2 py-0.5 rounded-full">Ativa</span>
                          ) : (
                            <span className="text-xs bg-stone-100 text-stone-600 px-2 py-0.5 rounded-full">Inativa</span>
                          )}
                          {frase.mostrar_em?.includes('login') && <span className="text-xs bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full">Login</span>}
                          {frase.mostrar_em?.includes('fim_tarefa') && <span className="text-xs bg-purple-100 text-purple-600 px-2 py-0.5 rounded-full">Fim Tarefa</span>}
                        </div>
                      </div>
                      <div className="flex gap-1">
                        <Button variant="ghost" size="sm" onClick={() => editarFrase(frase)}><Edit className="h-4 w-4" /></Button>
                        <Button variant="ghost" size="sm" onClick={() => eliminarFrase(frase.id)} className="text-red-500"><Trash2 className="h-4 w-4" /></Button>
                      </div>
                    </div>
                  </Card>
                ))
              )}
            </div>
          </div>
        )}

        {/* Dialog para nova ausência */}
        <Dialog open={showFormAusencia} onOpenChange={setShowFormAusencia}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>Nova Ausência</DialogTitle>
            </DialogHeader>
            <form onSubmit={handleSubmitAusencia} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-stone-700 mb-1">Operador *</label>
                <select
                  value={formAusencia.operador_id}
                  onChange={(e) => setFormAusencia({ ...formAusencia, operador_id: e.target.value })}
                  className="w-full p-2 border border-stone-300 rounded-lg"
                  required
                >
                  <option value="">Selecionar operador...</option>
                  {operadores.map(op => (
                    <option key={op.id} value={op.id}>{op.nome_completo}</option>
                  ))}
                </select>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-1">Data Início *</label>
                  <Input
                    type="date"
                    value={formAusencia.data_inicio}
                    onChange={(e) => setFormAusencia({ ...formAusencia, data_inicio: e.target.value })}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-stone-700 mb-1">Data Fim *</label>
                  <Input
                    type="date"
                    value={formAusencia.data_fim}
                    onChange={(e) => setFormAusencia({ ...formAusencia, data_fim: e.target.value })}
                    required
                  />
                </div>
              </div>
              {formAusencia.data_inicio && formAusencia.data_fim && (
                <div className="bg-blue-50 p-3 rounded-lg text-sm text-blue-700">
                  <strong>{calcularDiasUteis(formAusencia.data_inicio, formAusencia.data_fim)}</strong> dias úteis
                  (excluindo fins-de-semana e feriados)
                </div>
              )}
              <div>
                <label className="block text-sm font-medium text-stone-700 mb-1">Tipo</label>
                <select
                  value={formAusencia.tipo}
                  onChange={(e) => setFormAusencia({ ...formAusencia, tipo: e.target.value })}
                  className="w-full p-2 border border-stone-300 rounded-lg"
                >
                  {tiposAusencia.map((tipo) => (
                    <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-700 mb-1">Observações</label>
                <textarea
                  value={formAusencia.observacoes}
                  onChange={(e) => setFormAusencia({ ...formAusencia, observacoes: e.target.value })}
                  className="w-full p-2 border border-stone-300 rounded-lg"
                  rows={2}
                  placeholder="Notas adicionais..."
                />
              </div>
              <div className="flex justify-end gap-2 pt-4">
                <Button type="button" variant="outline" onClick={() => setShowFormAusencia(false)}>
                  Cancelar
                </Button>
                <Button type="submit">
                  <Plus className="h-4 w-4 mr-2" />
                  Registar
                </Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>

        {/* Dialog para gestão de tipos de ausência */}
        <Dialog open={showFormTipo} onOpenChange={(open) => {
          setShowFormTipo(open);
          if (!open) {
            setEditingTipo(null);
            setFormTipo({ nome: '', cor: 'bg-blue-500', corLight: 'bg-blue-50', textColor: 'text-blue-600' });
          }
        }}>
          <DialogContent className="max-w-lg">
            <DialogHeader>
              <DialogTitle>Tipos de Ausência</DialogTitle>
            </DialogHeader>
            
            {/* Lista de tipos existentes */}
            <div className="space-y-2 mb-6 max-h-60 overflow-y-auto">
              {tiposAusencia.map((tipo) => (
                <div 
                  key={tipo.id}
                  className={`flex items-center justify-between p-3 rounded-lg ${tipo.corLight}`}
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-4 h-4 rounded ${tipo.cor}`}></div>
                    <span className={`font-medium ${tipo.textColor}`}>{tipo.nome}</span>
                  </div>
                  <div className="flex gap-1">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => handleEditTipo(tipo)}
                      className="h-8 w-8"
                    >
                      <Edit className="h-4 w-4 text-stone-500" />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => handleDeleteTipo(tipo.id)}
                      className="h-8 w-8"
                    >
                      <Trash2 className="h-4 w-4 text-red-500" />
                    </Button>
                  </div>
                </div>
              ))}
            </div>

            {/* Formulário para criar/editar tipo */}
            <form onSubmit={handleSubmitTipo} className="space-y-4 border-t pt-4">
              <h4 className="font-medium text-stone-700">
                {editingTipo ? 'Editar Tipo' : 'Novo Tipo'}
              </h4>
              <div>
                <label className="block text-sm font-medium text-stone-700 mb-1">Nome *</label>
                <Input
                  value={formTipo.nome}
                  onChange={(e) => setFormTipo({ ...formTipo, nome: e.target.value })}
                  placeholder="Ex: Férias, Falta, Baixa..."
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-700 mb-2">Cor</label>
                <div className="flex flex-wrap gap-2">
                  {CORES_DISPONIVEIS.map((corOpt) => (
                    <button
                      key={corOpt.cor}
                      type="button"
                      onClick={() => setFormTipo({ ...formTipo, cor: corOpt.cor, corLight: corOpt.corLight, textColor: corOpt.textColor })}
                      className={`w-8 h-8 rounded-full ${corOpt.cor} ${formTipo.cor === corOpt.cor ? 'ring-2 ring-offset-2 ring-primary' : ''}`}
                    />
                  ))}
                </div>
              </div>
              <div className="flex justify-end gap-2 pt-4">
                <Button type="button" variant="outline" onClick={() => {
                  setEditingTipo(null);
                  setFormTipo({ nome: '', cor: 'bg-blue-500', corLight: 'bg-blue-50', textColor: 'text-blue-600' });
                }}>
                  Limpar
                </Button>
                <Button type="submit">
                  {editingTipo ? 'Guardar' : 'Criar Tipo'}
                </Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>

        {/* Dialog para detalhe do dia */}
        <Dialog open={showDayDetail} onOpenChange={setShowDayDetail}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>
                {selectedDay?.date?.toLocaleDateString('pt-PT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
              </DialogTitle>
            </DialogHeader>
            
            {selectedDay && (
              <div className="space-y-4">
                {/* Info do dia */}
                <div className="flex gap-2 flex-wrap">
                  {selectedDay.feriado && (
                    <span className="px-3 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-medium">
                      Feriado: {selectedDay.feriado.nome}
                    </span>
                  )}
                  {!selectedDay.diaTrabalho && !selectedDay.feriado && (
                    <span className="px-3 py-1 bg-stone-100 text-stone-600 rounded-full text-sm font-medium">
                      Fim de semana
                    </span>
                  )}
                  {selectedDay.diaTrabalho && !selectedDay.feriado && (
                    <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">
                      Dia de trabalho
                    </span>
                  )}
                </div>

                {/* Ausências do dia */}
                {selectedDay.ausencias.length === 0 ? (
                  <p className="text-stone-500 text-center py-4">Nenhuma ausência neste dia</p>
                ) : (
                  <div className="space-y-2">
                    <h4 className="font-medium text-stone-700">Ausências ({selectedDay.ausencias.length})</h4>
                    {selectedDay.ausencias.map((a) => {
                      const tipoConfig = getTipoConfig(a.tipo);
                      const estadoConfig = ESTADO_AUSENCIA[a.estado] || ESTADO_AUSENCIA.pendente;
                      return (
                        <div key={a.id} className={`p-3 rounded-lg ${tipoConfig.corLight}`}>
                          <div className="flex items-center justify-between">
                            <p className={`font-medium ${tipoConfig.textColor}`}>
                              {getOperadorNome(a.operador_id)}
                            </p>
                            <span className={`px-2 py-0.5 rounded-full text-xs text-white ${estadoConfig.color}`}>
                              {estadoConfig.label}
                            </span>
                          </div>
                          <p className="text-sm text-stone-600 mt-1">
                            {tipoConfig.nome} • {a.dias_uteis || 1} dia(s) útil(eis)
                          </p>
                          {a.estado === 'pendente' && (
                            <div className="flex gap-2 mt-2">
                              <Button size="sm" variant="outline" onClick={() => { handleAprovarAusencia(a.id); setShowDayDetail(false); }} className="text-green-600">
                                <Check className="h-3 w-3 mr-1" /> Aprovar
                              </Button>
                              <Button size="sm" variant="outline" onClick={() => { handleRejeitarAusencia(a.id); setShowDayDetail(false); }} className="text-red-600">
                                <X className="h-3 w-3 mr-1" /> Rejeitar
                              </Button>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </DialogContent>
        </Dialog>

        {/* Dialog para Balanço de Férias */}
        <Dialog open={showBalancoDialog} onOpenChange={setShowBalancoDialog}>
          <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <BarChart3 className="h-5 w-5" />
                Balanço de Férias {currentYear}
              </DialogTitle>
            </DialogHeader>
            
            <p className="text-sm text-stone-500 mb-4">
              Contabilização de dias de férias e ausências por operador (apenas dias úteis)
            </p>

            {/* Info dias anuais */}
            <div className="bg-blue-50 p-4 rounded-lg mb-6 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Calendar className="h-5 w-5 text-blue-600" />
                <span className="text-blue-700 font-medium">Dias de férias anuais por funcionário:</span>
              </div>
              <span className="text-2xl font-bold text-blue-700">{config.dias_ferias_anuais || 22} dias</span>
            </div>

            {/* Tabela de balanço */}
            {balancoOperadores.length === 0 ? (
              <div className="text-center py-8 text-stone-500">
                <Users className="h-12 w-12 mx-auto mb-2 text-stone-300" />
                Nenhum operador encontrado
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b">
                      <th className="text-left p-3 font-medium text-stone-700">Operador</th>
                      <th className="text-center p-3 font-medium text-blue-600">Férias Usadas</th>
                      <th className="text-center p-3 font-medium text-amber-600">Pendentes</th>
                      <th className="text-center p-3 font-medium text-green-600">Disponíveis</th>
                      {tiposAusencia.filter(t => t.id !== 'ferias').map(tipo => (
                        <th key={tipo.id} className={`text-center p-3 font-medium ${tipo.textColor}`}>{tipo.nome}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {balancoOperadores.map((b) => (
                      <tr key={b.operador.id} className="border-b hover:bg-stone-50">
                        <td className="p-3 font-medium">{b.operador.nome_completo}</td>
                        <td className="text-center p-3 text-blue-600 font-semibold">{b.diasFeriasUsados}</td>
                        <td className="text-center p-3 text-amber-600">{b.diasFeriasPendentes}</td>
                        <td className="text-center p-3 text-green-600 font-semibold">{b.diasFeriasDisponiveis}</td>
                        {tiposAusencia.filter(t => t.id !== 'ferias').map(tipo => (
                          <td key={tipo.id} className={`text-center p-3 ${tipo.textColor}`}>
                            {b.diasPorTipo?.[tipo.id] || 0}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Totais */}
            <div className="grid grid-cols-4 gap-4 mt-6 pt-4 border-t">
              <div className="text-center p-4 bg-stone-50 rounded-lg">
                <p className="text-xs text-stone-500 uppercase">Total Operadores</p>
                <p className="text-2xl font-bold text-stone-700">{totalOperadores}</p>
              </div>
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <p className="text-xs text-blue-500 uppercase">Dias Férias Usados</p>
                <p className="text-2xl font-bold text-blue-600">{totalFeriasUsados}</p>
              </div>
              <div className="text-center p-4 bg-red-50 rounded-lg">
                <p className="text-xs text-red-500 uppercase">Total Faltas</p>
                <p className="text-2xl font-bold text-red-600">{totalFaltas}</p>
              </div>
              <div className="text-center p-4 bg-orange-50 rounded-lg">
                <p className="text-xs text-orange-500 uppercase">Total Baixas</p>
                <p className="text-2xl font-bold text-orange-600">{totalBaixas}</p>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Diálogo de confirmação — Sair sem guardar */}
      <Dialog open={showUnsavedDialog} onOpenChange={setShowUnsavedDialog}>
        <DialogContent className="sm:max-w-md" data-testid="unsaved-changes-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-lg font-bold">
              <AlertCircle className="h-5 w-5 text-amber-500" />
              Alterações não guardadas
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm text-stone-600 mt-2">
            Tem alterações que ainda não foram guardadas. Deseja sair sem guardar?
          </p>
          <div className="flex gap-3 mt-4">
            <Button
              variant="outline"
              className="flex-1"
              onClick={() => setShowUnsavedDialog(false)}
              data-testid="btn-cancel-unsaved"
            >
              Cancelar
            </Button>
            <Button
              variant="destructive"
              className="flex-1"
              onClick={() => {
                setShowUnsavedDialog(false);
                setIsDirty(false);
                if (pendingTabRef.current) {
                  setActiveTab(pendingTabRef.current);
                  pendingTabRef.current = null;
                }
              }}
              data-testid="btn-discard-unsaved"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Sair sem guardar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </GestorLayout>
  );
}
